import React, { FunctionComponent } from "react";
import { useAuthProfile } from "../../utils/useAuthProfile";
import UserAccessControlUtils from "../../utils/UserAccessControlUtils";

type PermissionProtectedComponentProps = {
  requiredViewPermissions: string[];
};

const PermissionProtectedComponent: FunctionComponent<
  PermissionProtectedComponentProps
> = ({ requiredViewPermissions, children }) => {
  const [accessToken] = useAuthProfile();
  return accessToken &&
    UserAccessControlUtils.hasPermission(
      accessToken.permissions,
      requiredViewPermissions
    ) ? (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  ) : (
    <div />
  );
};

export default PermissionProtectedComponent;
